import { apiClient } from '@/shared/api';

export interface UploadedAsset {
  publicUrl: string;
}

export interface UploadTenantLogoParams {
  file: File;
  ownerId?: string;
}

const BASE = '/api/v1/store/settings/media/logo';

export const uploadTenantLogo = async ({
  file,
  ownerId,
}: UploadTenantLogoParams): Promise<UploadedAsset> => {
  const form = new FormData();
  form.append('file', file);
  if (ownerId) {
    form.append('ownerId', ownerId);
  }

  // Override Content-Type so axios doesn't keep apiClient's instance-default
  // 'application/json' here — if it did, axios's transformRequest would JSON.stringify
  // this FormData instead of leaving it as a multipart body (stage incident 2026-06-30:
  // the server rejected the resulting application/json PUT with a 415). apiClient's own
  // request interceptor then clears this value entirely so the browser can inject the
  // real 'multipart/form-data; boundary=...' — see shared/api/apiClient.ts.
  return (
    await apiClient.put<UploadedAsset>(BASE, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  ).data;
};
